import { BASE_URL } from "@/config"

export const getFileUrl = (url) => {
    return url ? `${BASE_URL}${url}` : ''
}

export function formatRoleName(roleCode: string): string {
  if (!roleCode) return '';
  return roleCode
    .replace(/_/g, ' ')
    .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

/** Extract filename from Content-Disposition (e.g. attachment; filename="invoice.pdf"). */
export function parseFilenameFromContentDisposition(
  contentDisposition: string | null | undefined
): string | null {
  if (!contentDisposition) return null;

  const utf8Match = contentDisposition.match(
    /filename\*\s*=\s*(?:UTF-8''|utf-8'')([^;]+)/i
  );
  if (utf8Match?.[1]) {
    const raw = utf8Match[1].trim().replace(/^["']|["']$/g, "");
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }

  const filenameMatch = contentDisposition.match(
    /filename\s*=\s*(?:"([^"]*)"|'([^']*)'|([^;\s]+))/i
  );
  if (filenameMatch) {
    const name = filenameMatch[1] ?? filenameMatch[2] ?? filenameMatch[3];
    return name?.trim() || null;
  }

  return null;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export async function downloadResponseFile(
  response: Response,
  fallbackFilename: string
): Promise<string> {
  const blob = await response.blob();
  const filename =
    parseFilenameFromContentDisposition(
      response.headers.get("Content-Disposition")
    ) || fallbackFilename;
  downloadBlob(blob, filename);
  return filename;
}
